module.exports = __webpack_public_path__ + "static/img/img_nohavedata.5d04b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_nohavedata.png
// module id = u1kv
// module chunks = 22